import { Button } from "@/components/ui/button";
import { Award, Coffee, Users } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import heroImage from "@/assets/hero-background.jpeg";

export const Hero = () => {
  const { t } = useLanguage();

  return <section id="inicio" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: `url(${heroImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    }}>
        <div className="absolute inset-0 bg-gradient-to-r from-espresso/95 via-espresso/80 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-block mb-4 px-4 py-2 bg-gold/20 rounded-full border border-gold/40">
            <span className="text-cream text-sm font-medium">{t("hero", "badge")}</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-cream mb-6 leading-tight">
            {t("hero", "title")}
          </h1>
          
          <p className="text-xl md:text-2xl text-cream/90 mb-8 leading-relaxed">
            {t("hero", "subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12 justify-center">
            <Button variant="premium" size="lg" asChild>
              <a href="#cursos">{t("hero", "verCursos")}</a>
            </Button>
            <Button variant="outline" size="lg" className="border-cream text-cream hover:bg-cream/10" asChild>
              <a href="#contacto">{t("hero", "contactar")}</a>
            </Button>
          </div>

          <div className="grid grid-cols-3 gap-6 max-w-2xl mx-auto">
            <div className="text-center">
              <Award className="w-8 h-8 text-gold mx-auto mb-2" />
              <div className="text-2xl font-bold text-cream">3x</div>
              <div className="text-sm text-cream/80">{t("hero", "campeonNacional")}</div>
            </div>
            <div className="text-center">
              <Coffee className="w-8 h-8 text-gold mx-auto mb-2" />
              <div className="text-2xl font-bold text-cream">10+</div>
              <div className="text-sm text-cream/80">{t("hero", "anosExperiencia")}</div>
            </div>
            <div className="text-center">
              <Users className="w-8 h-8 text-gold mx-auto mb-2" />
              <div className="text-2xl font-bold text-cream">500+</div>
              <div className="text-sm text-cream/80">{t("hero", "baristasFormados")}</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
